export default __webpack_public_path__ + "SoluceSecondPics.a631fe0.png";